function convertHtmlToPlainText(htmlString: string) {
  if (typeof document === "undefined") {
    // SSR fallback using regex-based tag stripping
    return htmlString ? htmlString.replace(/<[^>]*>?/gm, "") : "";
  }
  const tempDivElement = document.createElement("div");
  tempDivElement.innerHTML = htmlString;
  return tempDivElement.textContent || "";
}

export default convertHtmlToPlainText;
